<template>
	<div class="v-popover" :class="{active}" @mouseover="setPosition">
		<div class="v-popover-trigger">
			<slot name="trigger"/>
		</div>
		<div class="v-popover-content" :loading="loading" :class="{top,left}" ref="content" @click.stop>
      <v-pagination class="v-popover-pagination" @scroll-bottom="scrollBottom">
        <slot/>
      </v-pagination>
		</div>
	</div>
</template>

<script>
export default {
  props: {
    trigger: {
      default: "",
      validator(v) {
        return ["", "click", "hover"].includes(v);
      }
    }
  },
  data() {
    return {
      top: false,
      left: false,
      active: false,
      loading: false
    };
  },
  methods: {
    open() {
      if (!this.active) {
        window.emit("click");
        this.active = true;
      }
    },
    close() {
      if (this.active) {
        this.active = false;
      }
    },
    setPosition() {
      if (this.$refs.content) {
        let { innerWidth, innerHeight } = window,
          { offsetWidth, offsetHeight } = this.$refs.content,
          { top, left, right, bottom } = this.$el.getBoundingClientRect();
        (right = innerWidth - right), (bottom = innerHeight - bottom);
        this.top = bottom < offsetHeight && top > offsetHeight;
        this.left = right < this.$el.offsetWidth - offsetWidth;
      }
    },
    scrollBottom() {
      if ("load-next" in this.$listeners) this.loading = true;
      this.$emit("load-next", () => (this.loading = false));
    }
  },
  mounted() {
    let event = {
      click: "click",
      hover: "mouseover"
    }[this.trigger];
    if (event) {
      this.$el.addEventListener(event, e => {
        this.open(), e.stopPropagation();
      });
      if (this.trigger == "hover") {
        this.$el.addEventListener("mouseout", this.close);
        this.$refs.content.addEventListener("click", e => e.stopPropagation());
      }
    }
    window.addEventListener("click", this.close);
  },
  destroyed() {
    window.removeEventListener("click", this.close);
  }
};
</script>

<style lang="less">
.v-popover {
  position: relative;
  line-height: initial;
  display: inline-block;
  box-sizing: border-box;
  vertical-align: middle;
  > .v-popover-content {
    z-index: 1;
    opacity: 0;
    display: flex;
    color: initial;
    overflow: auto;
    min-width: 100%;
    margin-top: 4px;
    max-height: 300px;
    position: absolute;
    visibility: hidden;
    border-radius: 4px;
    background-color: #ffffff;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
    transform: translate3d(0, -50%, 0) scale3d(1, 0, 1);
    transition: 300ms;
    transition-delay: 200ms;
    &.top {
      bottom: 100%;
      margin-bottom: 4px;
      transform: translate3d(0, 50%, 0) scale3d(1, 0, 1);
    }
    &.left {
      right: 0;
    }
    > .v-popover-pagination {
      flex: 1;
    }
  }
  &.active {
    > .v-popover-content {
      z-index: 2;
      opacity: 1;
      visibility: visible;
      transform: translate3d(0, 0, 0) scale3d(1, 1, 1);
      transition-delay: 0ms;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue-ext/components/popover/index.vue